<template>
  <DxPopup
    :visible="showModal"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    title="Account Status"
    accesskey="status-popup"
    :showCloseButton="false"
    @shown="initialize"
    @hidden="hideModal"
    :height="'76%'"
    :wrapperAttr="wrapperAttr"
  >
    <gc-filter-split-view
      :showLeftContainer="showFilterLeftContainer"
      :showRightContainer="showFilterRightContainer"
    >
      <template #leftContent>
        <div class="status-popup">
          <dx-data-grid
            :data-source="accountStatusData"
            :columns="accountStatusColumns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="setGridHeight"
            ref="account-status-grid"
            @content-ready="addGridNoResults($event)"
          >
            <template #totalOutstanding="{ data }">
              <div>
                <div class="informer">
                  <span class="outstanding">Credit Limit </span>
                  <span class="outstanding-value"
                    >{{ customerCreditLimit }}
                  </span>
                </div>
                <div class="informer">
                  <span class="outstanding">Total Outstanding </span>
                  <span class="outstanding-value">{{ totalOutstanding }}</span>
                </div>
              </div>
            </template>
            <template #status-cell-template="{ data }">
              <gc-status-chip :status="data.data.PaymentStatus" />
            </template>
          </dx-data-grid>
          <div class="footer">
            <DxButton
              text="Back"
              type="default"
              styling-mode="contained"
              @click="hideModal"
            />
          </div>
        </div>
      </template>

      <template #rightContent>
        <gc-advance-filter-panel
          :toolbar="filterToolbar"
          :filterFormHeight="filterFormHeight"
          :sideBarTabs="sideBarTabs"
          :filterFormItems="filterFormItems"
          :filterModel="getAdvanceFilterModel"
          :isJson="false"
          :screenType="'account-status-list'"
          :data-source-config="accountStatusData"
          :defaultValues="defaultValue"
          :initial-filter="initialFilter"
        >
        </gc-advance-filter-panel>
      </template>
    </gc-filter-split-view>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
import { CustomerService } from "../_services/api/customers/customer.service";

var accountStatusDataSource = SalesOrderService.accountStatusDataSourceConfig({
  sort: [{ selector: "InvoiceCode/DisplayName", asc: true }],
});

export default {
  mixins: [BaseViewMixin],
  props: {
    showModal: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    showModal: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      handler: function(newVal, oldVal) {
        if (newVal) {
          this.$logger.trackEventOpenPopup("Account status modal");
        }
      },
    },
  },
  data() {
    return {
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Account Lines",
          message:
            "Our customer has paid for all their goods, or we have not sold them anything yet. Give them a call and sell them something today!",
        },
      },
      showFilterLeftContainer: true,
      showFilterRightContainer: false,
      totalOutstanding: 0,
      customerCreditLimit: 0,
      accountStatusData: accountStatusDataSource,
      modelAccountStatus: {
        InvoiceStatus: [],
        CustomerCode: "",
      },
      filterFormHeightAccountStatus: "auto",
      //   filterToolbar: {
      //     close: {
      //       icon: "showpanel",
      //       onClick: () => {
      //         this.showFilterRightContainer = !this.showFilterRightContainer;

      //         var grid = this.$refs["account-status-grid"].instance;
      //         grid.repaint();
      //       },
      //     },
      //     clear: {
      //       text: "Clear",
      //       onClick: () => {
      //         this.modelAccountStatus.InvoiceStatus = [];
      //       },
      //     },
      //   },
      defaultValue: {},
    };
  },

  computed: {
    initialFilter() {
      return ["CustomerCode", "=", this.modelAccountStatus.CustomerCode];
    },
    getAdvanceFilterModel() {
      return this.modelAccountStatus;
    },
    setGridHeight() {
      // 76 default toolbar height
      // 24 popup content padding
      // 60 space for footer button
      return window.innerHeight * 0.8 - 76 - 24 - 60;
    },
    filterFormItems() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "PaymentStatus",
              gcLabel: "Payment Status",
              gcType: "String",
              // label: { text: "Payment Status" },
              editorType: "dxTagBox",
              editorOptions: {
                items: [
                  { text: "Open", value: "Open" },
                  { text: "Overdue", value: "Overdue" },
                ],
                valueExpr: "value",
                displayExpr: "text",
                // onValueChanged: this.applyCustomFilterAccountStatus.bind(this),
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                deferRendering: false,
                columns: [
                  {
                    caption: "Code",
                    dataField: "value",
                  },
                ],
                // onSelectionChanged: this.tabBoxOnSelectionChangedAccountStatus.bind(
                //   this,
                //   "InvoiceStatus"
                // ),
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    accountStatusColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Invoice",
          dataField: "InvoiceCode",
          gcType: "String-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
          sortOrder: "desc",
        },
        {
          gcLabel: "Invoice",
          dataField: "InvoiceCodeAsString",
          gcSubType: "HiddenDescription",
          gcType: "String",
          width: 0,
          showInColumnChooser: false,
        },
        {
          gcLabel: "Inv Date",
          dataField: "DateIn",
          gcType: "Date",
        },
        {
          gcLabel: "Due Date",
          dataField: "DateDue",
          gcType: "Date",
        },
        {
          gcLabel: "Amount",
          gcType: "Decimal-6-2C",
          dataField: "Amount",
        },
        {
          gcLabel: "Balance",
          dataField: "Balance",
          gcType: "Decimal-6-2C",
        },
        {
          dataField: "PaymentStatus",
          gcType: "String",
          gcSubType: "Chip",
          cellTemplate: "status-cell-template",
          showInColumnChooser: false,
        },
      ]);
    },
  },
  methods: {
    initialize() {
      this.getCustomerData(this.parentModel.CustomerCode);
    },
    reset() {
      this.$logger.debug("ResetForm");
    },
    async hideModal() {
      this.reset();
      this.$emit("close-form");
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          template: "totalOutstanding",
        },
        searchPanel,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            elementAttr: { id: "filter-btn" },
            icon: "filter",
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              this.accountStatusData.reload();
            },
            visible: !this.showFilterRightContainer,
          },
        }
      );
    },
    applyCustomFilterAccountStatus() {
      const createFilter = [];
      createFilter.push([
        "CustomerCode",
        "=",
        this.modelAccountStatus.CustomerCode,
      ]);

      if (this.modelAccountStatus.InvoiceStatus.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.modelAccountStatus.InvoiceStatus.length;
          index++
        ) {
          if (this.modelAccountStatus.InvoiceStatus[index] == "Open") {
            // afilter.push(["DateDue", ">=", new Date().removeTime()]);
            afilter.push(["PaymentStatus", "=", "Open"]);
            if (index != this.modelAccountStatus.InvoiceStatus.length - 1) {
              afilter.push("or");
            }
          }

          if (this.modelAccountStatus.InvoiceStatus[index] == "Overdue") {
            // afilter.push(["DateDue", "<", new Date().removeTime()]);
            afilter.push(["PaymentStatus", "=", "Overdue"]);
            if (index != this.modelAccountStatus.InvoiceStatus.length - 1) {
              afilter.push("or");
            }
          }
        }
        createFilter.push(afilter);
      }

      if (createFilter.length == 0) {
        var grid = this.$refs["account-status-grid"].instance;
        grid.clearFilter();
      } else {
        accountStatusDataSource.filter(createFilter);
      }
      accountStatusDataSource.load();
    },
    async getTotalBalance(code) {
      await SalesOrderService.getTotalBalance({
        apply: `filter(CustomerCode eq '${code}')/aggregate(Balance with sum as TotalBalance)`,
      })
        .then((result) => {
          // this.$logger.debug("result getTotalBalance", result);
          this.totalOutstanding =
            "$" +
            result.data[0].TotalBalance.toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        })
        .catch((err) => {
          this.$logger.debug("err getTotalBalance", err);
        });
    },
    async getCustomerData(code) {
      CustomerService.getByCode(code)
        .then((result) => {
          this.modelAccountStatus.CustomerCode = result.data.value[0].Code;
          this.customerCreditLimit =
            "$" +
            result.data.value[0].CreditLimit.toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

          this.getTotalBalance(result.data.value[0].Code);
          accountStatusDataSource.filter([
            "CustomerCode",
            "=",
            result.data.value[0].Code,
          ]);
          accountStatusDataSource.load();
        })

        .catch((err) => {
          this.$logger.debug("getCustomerData err", err);
        });
    },
  },
};
</script>

<style></style>
